import { ShopperAgentShortfallKind } from "@redotech/crdb-enums/shopper-ai/shopper-agent-shortfall-kind";
import * as z from "zod";

export const getShopperAgentShortfallCauses = {
  name: "getShopperAgentShortfallCauses" as const,
  input: z.object({
    start: z.date(),
    end: z.date(),
    /** Empty means every kind. */
    kinds: z.array(z.enum(ShopperAgentShortfallKind)),
  }),
  output: z.object({
    /**
     * Shortfalls with a reason, one row per cause and subject. A shortfall
     * counts under every cause it likely shows, or once as `unclear`.
     */
    read: z.array(
      z.object({
        /** The shortfall analysis classifier's keys. */
        cause: z.string(),
        subject: z.string(),
        shortfalls: z.number(),
      }),
    ),
    /** The same shortfalls by subject, each counted once. Most first.
     * Optional while an older admin server still answers. */
    subjects: z
      .array(z.object({ subject: z.string(), shortfalls: z.number() }))
      .optional(),
    /** Shortfalls with a reason the hourly classifier has read. */
    analyzed: z.number().optional(),
    /** Shortfalls with a reason the hourly classifier hasn't read yet. */
    unread: z.number(),
  }),
};
